import axios from "axios";
import Vuex from "vuex";

const firstItem = {
  label: "全部",
  value: ""
};

const temp = {
  state: {
    categories: [],
    SelectCategory: {},
    styles: [],
    colors: []
  },
  mutations: {
    GET_CATEGORIES(state, data) {
      state.categories = data;
    },
    GET_STYLES(state, data) {
      state.styles = data;
    },
    GET_COLORS(state, data) {
      state.colors = data;
    }
  },
  actions: {
    getCategories({ commit }) {
      axios.get("/designer_api/dictionaries/category").then(res => {
        res.unshift(firstItem);
        commit("GET_CATEGORIES", res);
      });
    },
    getStyles({ commit }) {
      axios.get("/designer_api/dictionaries/style").then(res => {
        res.unshift(firstItem);
        commit("GET_STYLES", res);
      });
    },
    getColors({ commit }) {
      axios.get("/designer_api/dictionaries/color").then(res => {
        res.unshift(firstItem);
        commit("GET_COLORS", res);
      });
    }
  }
};

export default temp;
